module.exports = __webpack_public_path__ + "img/home-menu-1.5ea696a9.png";